import React from "react";

const TitleMain = props => {
    return (
        <React.Fragment>
            <hr />
            <h1 className="title-report text-center">{props.title}</h1>
        </React.Fragment>
    ) 
}

export default TitleMain;
